<template>
  <div class="user_page inventory_page">
    <h3 class="title-page">{{ $t("reportWriteOff") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main inventory_main_table">
          <div class="inventory_table">
            <table-with-filter :headers="headers" :items="items">
              <template #filter.productName>
                <div class="pa-1">
                  <vue-select
                    :get-item-promise="
                      ({ text, page }) =>
                        $store.dispatch('getProducts', {
                          name: text,
                          page,
                          limit: 15,
                        })
                    "
                    @item-resolved="setProduct"
                    @next-page-resolved="
                      (data) => setProduct([...products, ...data])
                    "
                    :items="products"
                    v-model="filter.productId"
                    @input="onChangeFilter"
                    clearable
                    infinite
                    name="select_on_block"
                  >
                    <template #option="{ item }">
                      <v-list-item-title>
                        <p class="ma-0">{{ item.name }}</p>
                        <span class="v-messages">{{
                          item.attrs.join(" && ")
                        }}</span>
                      </v-list-item-title>
                    </template>
                  </vue-select>
                </div>
              </template>
              <template #filter.writeOffDate>
                <div class="data_block d-flex align-center">
                  <span class="custom_input_label pt-1 mr-2">{{
                    $t("from")
                  }}</span>
                  <custom-date-picker
                    clearable
                    @input="getProductWithLoading"
                    v-model="filter.fromDate"
                    hide-details
                    color="#E3EBF3"
                    class="mr-1 user_input ml-1 data_item data_item_calendar"
                    icon="mdi-calendar-month small"
                  ></custom-date-picker>
                  <span class="custom_input_label pt-1">{{ $t("to") }}</span>
                  <custom-date-picker
                    hide-details
                    clearable
                    :min="filter.fromDate"
                    @input="getProductWithLoading"
                    :start-day="false"
                    v-model="filter.toDate"
                    name="calendar_t"
                    color="#E3EBF3"
                    class="user_input data_input_tw data_item ml-2 data_item"
                    icon="mdi-calendar-month small"
                  ></custom-date-picker>
                </div>
              </template>
              <template #item.count="{ item }">{{
                item.count | numberParse
              }}</template>
              <template #item.receiverDate="{ item }">{{
                item.contractItemAcceptedDate | dateParse
              }}</template>
              <template #item.productAttrs="{ item }">
                {{ item.productAttrs.join(" || ") }}
              </template>
              <template
                #item.writeOffDate="{
                  /**
                   * @type Object
                   * @property writeOffDate
                   */ item,
                }"
                >{{ item.writeOffDate | fullTimeParse }}</template
              >
              <template #item.takenAwayDate="{ item }">{{
                item.takenAwayDate | fullTimeParse
              }}</template>
              <template #item.unitTypeName="{ item }">{{
                item[`unit_type_name_${$i18n.locale}`]
              }}</template>
              <template
                #item.action="{
                  /**
                   * @type Object
                   * @property usedFileName
                   * @property usedFileLink
                   */ item,
                }"
              >
                <downloader
                  :file-name="item.usedFileName"
                  :address="item.usedFileLink"
                />
              </template>
            </table-with-filter>
            <vue-pagination
              v-model="options.page"
              :length="lastPage"
              @input="changePage"
              go-to
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import { PRODUCT_ITEM_STATUS } from "@/utils/constants";
import {
  getQueryByKey,
  getQueryPage,
  makerPagination,
} from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import Downloader from "@/components/ui/downloader";
import VueSelect from "@/components/ui/vue-select/VueSelect";

export default {
  components: { VueSelect, Downloader, VuePagination, TableWithFilter },
  data: () => ({
    items: [],
    products: [],
    lastPage: 0,
    options: {
      page: 1,
      limit: 15,
    },
    filter: {
      productId: null,
    },
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("product"), value: "productName" },
        { text: this.$t("attributes"), value: "productAttrs" },
        { text: this.$t("count"), value: "count" },
        { text: this.$t("unit"), value: "unitTypeName" },
        { text: this.$t("writeOffTime"), value: "writeOffDate" },
        { text: this.$t("writeOffByUser"), value: "writeOffByUser" },
        { text: this.$t("comment"), value: "comment" },
        { text: this.$t("action"), value: "action" },
      ];
    },
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    changePage(page) {
      this.$router.replace({ query: { ...this.filter, page: `${page}` } });
      this.getProductWithLoading();
    },
    onChangeFilter() {
      this.options.page = 1;
      this.$router
        .replace({ query: { ...this.filter, page: "1" } })
        .catch((err) => {
          console.warn(err);
        });
      this.getProductWithLoading();
    },
    async getProductWithLoading() {
      this.showLoading();
      await this.getProducts();
      this.clearLoading();
    },
    async getProducts() {
      const params = {
        ...this.options,
        ...this.filter,
        page: this.options.page - 1,
        state: PRODUCT_ITEM_STATUS.PRODUCT_USED,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("product-item/own-product", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({
          limit: params.limit,
          total,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  created() {
    this.options.page = getQueryPage(this.$route.query.page, this.options.page);
    this.filter = getQueryByKey(this.filter, this.$route.query);
    this.getProductWithLoading();
  },
};
</script>
